var map = {
	"./37198235_s.jpg": 408,
	"./clouds-cloudy-agriculture-farm.jpg": 4236,
	"./eggs-happen-food-ecology-161496.jpg": 7861,
	"./food-healthy-vegetables-potatoes.jpg": 3955,
	"./food-vegetables-beans-green.jpg": 6731,
	"./fruits-grocery-bananas-market.jpg": 3633,
	"./headache-pain-pills-medication-159211.jpg": 1945,
	"./iStock-173010881.jpg": 1557,
	"./iStock-174993900.jpg": 316,
	"./iStock-181859722.jpg": 735,
	"./iStock-185273188.jpg": 3819,
	"./iStock-483856797.jpg": 2313,
	"./iStock-522381893.jpg": 5937,
	"./pexels-photo-237635.jpg": 7533,
	"./pexels-photo-248152.jpg": 1381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8131;